
//数据 state
const state = {
  isPreventDefault: true,    // 是否阻止默认(键盘/鼠标)事件
  isClipboardEmpty: true,     // 剪切板是否为空
  shortcutType: 'editor',       // 快捷键对应状态
}

//获取数据 getters
const getters = {
  isPreventDefault: state => state.isPreventDefault,
  isClipboardEmpty: state => state.isClipboardEmpty,
  shortcutType: state => state.shortcutType,
}

//修改数据 mutations
const mutations = {
  toggle_isPreventDefault(state, data) {
    // 设置是否阻止默认事件
    state.isPreventDefault = data;
  },
  toggle_isClipboardEmpty(state, data) {
    state.isClipboardEmpty = data;
  },
  toggle_shortcutType(state, data) {
    state.shortcutType = data;
  },
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shortcut.js